"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'download2Go';
exports.SET_DOWNLOAD_ASSET = exports.namespace + "/SET_DOWNLOAD_ASSET";
exports.SET_ALL_DOWNLOAD_ASSETS = exports.namespace + "/SET_ALL_DOWNLOAD_ASSETS";
exports.REMOVE_DOWNLOAD_ASSET = exports.namespace + "/REMOVE_DOWNLOAD_ASSET";
exports.SET_DOWNLOAD_SETTINGS = exports.namespace + "/SET_DOWNLOAD_SETTINGS";
exports.SET_WIFI_ONLY = exports.namespace + "/SET_WIFI_ONLY";
//# sourceMappingURL=constants.js.map